import { Component, OnInit, OnDestroy, ViewChild, Input, Output, OnChanges, SimpleChange, AfterViewInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

import { NormasService } from "../_services/normas.service";

import { Nivel } from '../_models/nivel.model';
import { Pregunta } from '../_models/pregunta.model';

import { EvidenciasService } from '../_services/evidencias.service';
import { ModalDirective } from 'ng2-bootstrap/modal';

import {ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';

declare var jQuery: any;

@Component({
  selector: 'modalenlacenormas',
  templateUrl: 'modalenlacenormas.template.html'
})
export class ModalEnlaceNormasComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit{

  @Input() _mostrarmodal: any;
  @Input() _id: any;
  @Input() _desde: string = "norma";

  @Output() onChangeModalEnlace = new EventEmitter<any>();

  @ViewChild('staticModalRespuestas') public staticModalRespuestas:ModalDirective;

  listamodulos: any = [];
  listanormas: any = [];
  listamodulosseleccionados: any = [];
  listanormasenlazadas: any = [];
  listaNormasFiltro: any = [];

  listaevidencias: any = [];
  listaevidenciashijo: any = [];
  id_jerarquia: number = 0;
  listaevidenciasjerarquia: any = [];
  normasel: any;

  sortdirection: string = "asc";

  public filterQuery = "";

  mostrarFiltros:boolean = false;
  cargando:boolean = false;

  constructor(private seguridad: SeguridadService,
              private router:Router,
              private normasService: NormasService,
              private globalEventsManager: GlobalEventsManager,
              private confirmationService: ConfirmationService,
              private evidenciasService: EvidenciasService,
              private activatedRoute: ActivatedRoute){

  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    /*if (changes['_id_respuesta']){
      this.id_respuesta = changes['_id_respuesta'].currentValue;
    }*/

    this.getListaNormas();
    this.getNormasAsociadas();

  }

  ngOnInit(){

  }

  ngOnDestroy(){

  }

  ngAfterViewInit(){
    this.abrirModal();
  }

  getListaNormas(){
    //this.normasService.getListaNormas();
    this.cargando = true;
    this.normasService.getListaNormasMaestras(0).subscribe(
      data => {
        this.listanormas = data.json().lista;
        this.listaNormasFiltro = data.json().lista;
        this.cargando = false;

      }
    );
  }

  abrirModal(){
    if (this._mostrarmodal){
      this.staticModalRespuestas.show();
    }
  }

  cerrarModal(){
    this.staticModalRespuestas.hide();
    this.onChangeModalEnlace.emit("");
  }

  anadirNorma(norma: any){
    let encontrado = 0;
    for (let nor of this.listanormasenlazadas){
      if(nor.id_norma == norma.id_norma){
        encontrado = 1;
      }
    }


    if (encontrado == 0){

      this.normasService.setNormaMaestraAsociaNorma(norma.id_norma, this._id).subscribe(
        data => {
          if (data){

            let al: any = {
              "texto" : "Módulos afectados actualizados",
              "mostrar": true
            };
            this.globalEventsManager.setAlert(al);

            this.listanormasenlazadas.push(norma);

            this.getNormasAsociadas();

          }
        }
      );


    }
  }

  eliminarNorma(index: number){

    let norma: any = this.listanormasenlazadas[index];

    this.normasService.delNormaMaestraAsociaNorma(norma.id_jerarquia).subscribe(
      data => {
        if (data){

          this.listanormasenlazadas.splice(index,1);
          this.getNormasAsociadas();

          this.id_jerarquia = 0;

        }
      }
    );

  }

  getNormasAsociadas(){


    this.normasService.getNormaMaestraAsociaNorma(this._id).subscribe(
      data => {
        if (data){

          this.listanormasenlazadas = data.json().lista;

        }
      }
    );

  }

  getListaEvidenciasJerarquia(id_norma: any){

    this.evidenciasService.getListaEvidenciaJerarquia(this.id_jerarquia).subscribe(
      data => {
        if (data){

          this.listaevidenciasjerarquia = data.json().lista;

          this.getListaEvidencias(id_norma);

        }
      }
    );
  }


  getListaEvidenciasHijo(id_norma: any){

    this.evidenciasService.getListaEvidenciasMaestraNorma(id_norma).subscribe(
      data => {
        if (data){

          this.listaevidenciashijo = data.json().lista;

          for (let evidencia of this.listaevidenciashijo){
            evidencia.id_evidencia_padre = 0;
            for (let evi of this.listaevidenciasjerarquia){
              if (evi.id_evidencia_hija == evidencia.id_evidencia){
                evidencia.id_evidencia_padre = evi.id_evidencia_padre;
              }
            }
          }

        }
      }
    );
  }

  getListaEvidencias(id_norma: any){

    this.evidenciasService.getListaEvidenciasMaestraNorma(id_norma).subscribe(
      data => {
        if (data){

          this.listaevidencias = data.json().lista;

          this.getListaEvidenciasHijo(this._id);

        }
      }
    );
  }

  updateRelaciones(id_jerarquia: number, id_norma: number){
    this.id_jerarquia = id_jerarquia;
    this.getListaEvidenciasJerarquia(id_norma);
  }

  setEvidenciaJerarquia(evidencia: any){

    this.evidenciasService.asociaEvidenciaJerarquia(this.id_jerarquia, evidencia.id_evidencia, evidencia.id_evidencia_padre).subscribe(
      data => {
        if (data){

        }
      }
    );

  }

  confirmBorrar(index: number) {
      this.confirmationService.confirm({
          message: '¿Seguro que deseas eliminar la relación?',
          accept: () => {
              this.eliminarNorma(index);
          }
      });
  }

  //---------------------------------------------------------------------
//-                            FILTROS
//---------------------------------------------------------------------
   
  limpiarFiltros(){

    this.getListaNormas();

  }


  changeValueNormaFiltros(filtro){

    this.listanormas = filtro;
    if (filtro.tipo == 'limpiar' ){
      this.limpiarFiltros();      
    }else{
      this.listanormas = filtro.value;
   
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/normas/modalenlacenormas.component.ts